import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import helpers from '../../helpers/index';
import * as helper_family_tree from '../../helpers/helper-family-tree';
import family_api from '../../api/family-api';
import ErrorSummary from '../error-summary';
import moment from 'moment';
import { radix_bases } from '../../helpers/helper-number-bases';
import disease_api from '../../api/disease-api';
import settings from "../../configs/settings";
import * as patient_actions from '../../store/patient/actions';
import Select, { components } from "react-select";
import { cloneDeep, isString } from "lodash";
import Cookie from 'js-cookie';
import DatePicker from 'react-date-picker';
import { CookieKeys } from './pedigree-constants';
import {
  ageOptions,
  stringToAge,
  yearBirthToAgeString,
  updateYear,
  ageStringToAgeInt,
  ageStringToYOB } from '../../helpers/age-utils'

import jQuery from 'jquery'
import route_helper from '../../route-helper'
import {set_cookie} from "../../helpers/helper-cookies";

let donor_type_options = [
  { value: "sperm_donor", label: "Sperm Donor" },
  { value: "egg_donor", label: "Egg Donor" },
  { value: "surrogate", label: "Surrogate" },
  { value: "surrogate_egg_donor", label: "Surrogate Egg Donor" }
]

class MemberInfo extends Component {

  constructor(props) {
    super(props)
    this.donorSelectRef = React.createRef();
    this.state = {
      profile: null,
      enablePregnancy: true,
      adopted: null,
      showMore: false,
      genderError: false,
      ageError: false,
      deceaseError: false,
      donor_types_selected: [],
      errorMessages: [],
      donorAssignReady: false,
    };

    this.pending_changes = false;
    this.timer = null

    this.handleOkClick = this.handleOkClick.bind(this);
    this.handleProfileChange = this.handleProfileChange.bind(this);
    this.onChangeDate = this.onChangeDate.bind(this);
    this.toggleShowMore = this.toggleShowMore.bind(this);

    this.getYearOfBirth = this.getYearOfBirth.bind(this);
    this.getProfileValue = this.getProfileValue.bind(this);
    this.validate = this.validate.bind(this);
    this.saveParentAdopted = this.saveParentAdopted.bind(this);
    this.onChange = this.onChange.bind(this);
    this.enablePregnancy = this.enablePregnancy.bind(this);
    this.handleGenderChange = this.handleGenderChange.bind(this);

    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.autoSaveProfile = this.autoSaveProfile.bind(this);
    this.setPendingChanges = this.setPendingChanges.bind(this);
    this.getPendingChanges = this.getPendingChanges.bind(this);
    this.getAgeValue = this.getAgeValue.bind(this);
    this.normalizeAge = this.normalizeAge.bind(this);
    this.handleAgeChange = this.handleAgeChange.bind(this);
    this.handleDonorFieldChange = this.handleDonorFieldChange.bind(this);

    this.handleClickUnlink = this.handleClickUnlink.bind(this);
    this.navigateToRecord = this.navigateToRecord.bind(this);
    this.handleAssignDonorClick = this.handleAssignDonorClick.bind(this);
    this.donorAssignReadyOn = this.donorAssignReadyOn.bind(this);
    this.donorAssignReadyOff = this.donorAssignReadyOff.bind(this);
  }

  componentDidMount() {
    if (this.props.node.data && this.props.node.data.profile) {
      let profile = cloneDeep(this.props.getPedigreeData().getProfile(this.props.node.data.profile.rkey))
      profile.yob = this.getYearOfBirth(profile);
      let enablePregnancy = this.enablePregnancy();

      let adopted = null;
      if(profile.adopted_in) {
        adopted = settings.adopted_status_options[0].value;
      } else if (profile.adopted_out) {
        adopted = settings.adopted_status_options[1].value;
      }

      // To make sure focused element stays focused after pedigree re-renders
      let last_focused_element_id = localStorage.getItem('famgenix_member_info_last_focused')
      let last_focused_element = document.getElementById(last_focused_element_id)

      if(last_focused_element) {
        last_focused_element.focus();
        localStorage.removeItem('famgenix_member_info_last_focused')
      }

      let donors = this.props.getPedigreeData().getDonors().filter(donor => donor.child_id == this.props.node.data.profile.id);
      let donor_types_selected = donors.map(donor => {
        return donor_type_options.find(option => option.value == donor.donor_type)
      });

      this.setState({profile, adopted, enablePregnancy, donor_types_selected});
    }
    this.timeout = null;
    document.addEventListener('click', this.handleClickOutside, true);

    // jQuery('#view-record-member-infoo').on('click', this.navigateToRecord);
  }

  navigateToRecord(e, member_id){
    if(e.type == 'click'){
      if (e.ctrlKey || e.metaKey){

        let url = route_helper.pedigree.pedigree_root.replace(":member_id", member_id) + "/#family-history";
        // focus on new window or just stay on the window?
        let newWindow = window.open(url)
        newWindow.blur();
        window.focus();
      }
      else{
        this.props.navigateToRecord(member_id);
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, true);
    // before exiting or changing the focus to another node,
    // save if there are pending changes
    this.autoSaveProfile();
    localStorage.setItem('famgenix_member_info_last_focused', document.activeElement.id)

    // jQuery('#view-record-member-infoo').off('click', this.navigateToRecord);
  }

  handleClickOutside(event) {
    const domNode = ReactDOM.findDOMNode(this);
    // add a new condition where it shouldn't fire when one click add menus are clicked
    // there is a function back then with the classnames of those menus

    // let nodeName1 = event?.target?.nodeName
    // let nodeName2 = event?.target?.parentNode?.nodeName
    // let nodeName3 = event?.target?.parentNode?.parentNode?.nodeName

    // //Make sure clicking the menus doesn't add on node click count
    // if(nodeName1 == 'BUTTON' || nodeName2 == 'BUTTON' || nodeName3 == 'BUTTON' || nodeName1 == 'A' || nodeName2 == 'A' || nodeName3 == 'A'){
    //   return;
    // }
    if(!domNode || !domNode.contains(event.target)) {
      // save profile data only if anything has changed
      // this may not be needed anymore since it autosaves when it's closed on
      //componentWillUnmount function, and this is commented out because it's
      //causing a second call to save, making the saving of sidebar information slower

      //adding back in to save age incase trying to update age dx
      //shouldn't make a second call to save any more since there will be no more pending changes

      // commenting this out again, talked to Travis about this, and it shouldn't
      // affect update of age/age dx
      // this.autoSaveProfile();
    }
    if (event.target.className === 'react-flow__pane') {
      set_cookie(CookieKeys.SIDEBAR_SHOW_MORE, false)
    }
  }

  autoSaveProfile() {
    // auto save profile data only if anything has changed
    if (this.getPendingChanges()) {
      this.handleOkClick();
    }
  }

  setPendingChanges(pending_changes) {
    this.pending_changes = pending_changes;
  }

  getPendingChanges() {
    return this.pending_changes;
  }

  getYearOfBirth(profile) {
    if(profile.yob !== null) return profile.yob

    if(profile.dob !== null) return moment(profile.dob).year()

    // if(!profile.is_dead) {
    //   if(profile.age !== null && profile.age != '0') {
    //     let age = parseInt(profile.age, radix_bases.base10)
    //     let current_year = moment().year()
    //     return current_year - age
    //   }
    // }

    return ''
  }

  getProfileValue(field) {
    if(this.state.profile && field in this.state.profile) {
      return this.state.profile[field]
    }

    return ''
  }



  getAgeValue(){
    clearTimeout(this.timer);
    let finalAge = ''
    if(this.state.profile && 'age_string' in this.state.profile && this.state.profile['age_string'] !== null) {
      finalAge = this.state.profile['age_string']
    }else if(this.state.profile && 'age' in this.state.profile){
      finalAge = this.state.profile['age']
    }

    // Sets new timer that may or may not get cleared
    this.timer = setTimeout(() => {
      this.normalizeAge(finalAge)
      clearTimeout(this.timer);
    }, 1000);

    return finalAge
  }


  normalizeAge(finalAge){
    let profile = cloneDeep(this.state.profile);
    let age_string = ''
    let convertedAge = ''

    if(finalAge && isString(finalAge)){
      let ageKey = ''
      let ageOption = finalAge.replace(/\d+/g, '').trim();
      let ageInt = parseInt(finalAge, radix_bases.base10)
      for(let key in ageOptions){
        if(ageOption.startsWith(ageOptions[key])){
          ageKey = key
        }
      }

      age_string = (ageInt && ageKey!== '') ?  `${ageInt}${ageKey}` : ageInt ? `${ageInt}` : ''
      //converst string to age in decimal
      convertedAge = stringToAge(ageInt, ageKey)

      // Check and make sure age + yob is not greater than current year
      // if(this.getProfileValue('is_dead')) {
      //   let yob = profile['yob'];
      //   if(convertedAge > 0) {
      //     let year = moment().year();
      //     if(convertedAge + parseInt(yob, radix_bases.base10) > parseInt(year, radix_bases.base10)) {
      //
      //       profile['dob'] = '';
      //       profile['yob'] = '';
      //     }
      //   }
      // } else {
      //
      //   if(convertedAge > 0) {
      //     let year = ageStringToYOB(age_string)
      //     let dob = profile['dob']
      //     if(dob !== undefined && dob !== null && dob !== "") {
      //       if(moment().dayOfYear() < moment(dob).dayOfYear()) year -= 1;
      //       profile['dob'] = year.toString() + moment(dob).format('-MM-DD');
      //     }
      //     profile['yob'] = year;
      //   }
      // }
      profile['age_string'] = age_string.trim()
      profile['age'] = convertedAge

      if (!isNaN(profile['age'])) {
        this.setState({ profile });
      }
    }
  }

  async onChangeDate(e) {
    let profile = cloneDeep(this.state.profile);
    if(e == null) {
      profile["dob"] = null;
    } else {
      let fullYear = e.getFullYear()
      let month = e.getMonth() + 1;
      if (month < 10) {
        month = `0${month}`;
      }

      let day = e.getDate();
      if (day < 10) {
        day = `0${day}`;
      }

      const string_dob = fullYear + "-" + month + "-" + day;
      profile["dob"] = string_dob;

      // Check and make sure age + yob is not greater than current year
      if (this.getProfileValue("is_dead")) {
        let age = profile["age"]
        if (string_dob !== "") {
          let year = moment().year();
          let yob = year - moment().diff(string_dob, "years");
          if (
            parseFloat(age, radix_bases.base10) +
              parseInt(yob, radix_bases.base10) >
            parseInt(year, radix_bases.base10)
          ) {
            profile["age"] = "";
            profile["age_string"] =""
            profile["yob"] = moment(string_dob).year();
          }
        }
      } else {
        if (string_dob !== "") {
          let age_string = yearBirthToAgeString(string_dob)
          let age = ageStringToAgeInt(age_string)
          profile['age'] = age
          profile["age_string"] = age_string;
          profile["yob"] = moment(string_dob).year();
        }
      }
    }

    this.setState({ profile });
    this.setPendingChanges(true);
  }


  handleAgeChange(e){
    let profile = cloneDeep(this.state.profile);
    if (profile) {
      let age =  e.target.value;
      let ageOption = age.replace(/\d+/g, '').trim();
      if (ageOption.includes('.') || ageOption.includes('/') || ageOption.includes(',')) return

      let diseases = cloneDeep(profile.diseases)
      let diagnosis_over_age_entered = diseases.filter(disease => parseInt(disease.age_diagnosed, radix_bases.base10) > parseInt(age, radix_bases.base10))

      if(diagnosis_over_age_entered.length > 0){
        this.setState({ ageError: true })
      }
      else{
        this.setState({ ageError: false })
      }

      if(profile.relationship_data){
        let people = Object.values(this.props.getPedigreeData().getAllProfiles())
        let children = people.filter(person => (person.mother_id == profile.relationship_data.mother_id && person.father_id == profile.relationship_data.father_id) ||
                        (person.father_id == profile.relationship_data.mother_id && person.mother_id == profile.relationship_data.father_id))

        let childrenWithYob = children.filter(child => (child.yob !== null && child.yob !== undefined && !isNaN(child.yob)))
        if(childrenWithYob.length !== 0){
          if(profile.is_dead && profile.yob && age){
            let highestYobAmongChildren = childrenWithYob.sort((a, b) => Number(b.yob) - Number(a.yob));
            highestYobAmongChildren = highestYobAmongChildren[0]
            if(Number(age) + Number(profile.yob) < Number(highestYobAmongChildren.yob)){
              this.setState({deceaseError: "Deceased date is before child/children's date of birth."})
            } else {
              this.setState({deceaseError: false})
            }
          }
        }
      }

      profile["age_string"] = age
      this.setPendingChanges(true);
      this.setState({profile}, () => {
        profile["age"] = this.getAgeValue();
        this.setState({profile})
      });
    }
  }

  handleProfileChange(e) {
    let profile = cloneDeep(this.state.profile);
    if (profile) {

      if(e.target.type == 'checkbox') {
        profile[e.target.name] = e.target.checked
      } else {
        profile[e.target.name] = e.target.value
      }

      if(e.target.name === 'is_dead' && e.target.checked === false) {
        this.setState({ deceaseError: false })
        profile['cause_of_death'] = ''
        if (this.props.node.data.profile.id === parseInt(this.props.probandId) ) {
          profile['age'] = moment().diff(profile['dob'], "years").toString();
          profile["age_string"] =  moment().diff(profile['dob'], "years").toString();
        } else {
          profile['age'] = (moment().year() - parseInt(profile['yob'], radix_bases.base10)).toString();
          profile["age_string"] =  (moment().year() - parseInt(profile['yob'], radix_bases.base10)).toString();
        }
      }

      // Calculate age from yob
      if(e.target.name == 'yob') {
        let yob =  e.target.value;

        // Check and make sure age + yob is not greater than current year
        if(this.getProfileValue('is_dead')) {
          let age = profile['age'];
          if(yob !== '') {
            let year = moment().year();
            if(parseInt(age, radix_bases.base10) + parseInt(yob, radix_bases.base10) > parseInt(year, radix_bases.base10)) {
              profile['age'] = '';
              profile['age_string'] = '';
            }
          }

        } else {

          if(yob !== '' && yob.length == 4) {
            let age = (moment().year() - parseInt(yob, radix_bases.base10)).toString()
            if(age){
              profile['age_string'] = age
              profile['age'] = age
            }
          }
        }
      }

      // Calculate yob (and dob if proband) from age
      // Calculate age from dob
      if(e.target.name == 'dob') {
        let dob =  e.target.value;

        // Check and make sure age + yob is not greater than current year
        if(this.getProfileValue('is_dead')) {
          let age = profile['age'];
          if(dob !== '') {
            let year = moment().year();
            let yob = year - moment().diff(dob, 'years');
            if(parseInt(age, radix_bases.base10) + parseInt(yob, radix_bases.base10) > parseInt(year, radix_bases.base10)) {
              profile['age'] = '';
              // profile['age_string'] ='';
              profile['yob'] = moment(dob).year();
            }
          }

        } else {

          if(dob !== '') {
            let age = moment().diff(dob, "years");
            if(age) {
              profile['age_string'] = age;
              profile['age'] = age;
            }
            profile['yob'] = moment(dob).year();
          }
        }
      }

      //For some reason, the diseases is not being cloned on the selectedNode object being passed when updated in current session,
      //so we get it from the actual pedigree data
      if(this.props.getPedigreeData !== undefined && this.props.getPedigreeData !== null){
        let retain_diseases = this.props.getPedigreeData().getDiseases(profile.rkey)
        profile.diseases = cloneDeep(retain_diseases)
      }

      if(profile.relationship_data){
        let people = Object.values(this.props.getPedigreeData().getAllProfiles())
        let children = people.filter(person => (person.mother_id == profile.relationship_data.mother_id && person.father_id == profile.relationship_data.father_id) ||
                        (person.father_id == profile.relationship_data.mother_id && person.mother_id == profile.relationship_data.father_id))

        let childrenWithYob = children.filter(child => (child.yob !== null && child.yob !== undefined && !isNaN(child.yob)))
        if(childrenWithYob.length !== 0){
          if(profile.is_dead && profile.yob && profile.age){
            let highestYobAmongChildren = childrenWithYob.sort((a, b) => Number(b.yob) - Number(a.yob));
            highestYobAmongChildren = highestYobAmongChildren[0]
            if(Number(profile.age) + Number(profile.yob) < Number(highestYobAmongChildren.yob)){
              this.setState({deceaseError: "Deceased date is before child/children's date of birth."})
            } else {
              this.setState({deceaseError: false})
            }
          }
        }
      }

      if(profile.mother_id !== null && profile.mother_id !== undefined && profile.mother_id !== ""){
        let people = Object.values(this.props.getPedigreeData().getAllProfiles())
        let mother = people.find(person => person.id == profile.mother_id)
        if(mother.is_dead && mother.yob && mother.age && profile.yob){
          if(Number(profile.yob) > Number(mother.yob) + Number(mother.age)){
            this.setState({deceaseError: "Birth date is after mother's deceased date."})
          } else {
            this.setState({deceaseError: false})
          }
        }
      }

      this.setPendingChanges(true);
      this.setState({profile});
    }
  }

  async handleOkClick() {
    try {
      this.setState({ errorMessages: [] });
      await this.validate();

      // Build payload and save to API
      let gender = this.state.profile.gender ? this.state.profile.gender.toLowerCase() : null;

      // we do not need to defualt to null for unknown anymore
      // if(gender === 'u') gender = null;

      let gender_identity = this.state.profile.gender_identity ? this.state.profile.gender_identity.toLowerCase() : null;

      let adopted_in = false;
      let adopted_out = false;
      let adopted = this.state.adopted;
      if(adopted != null) {
        adopted_in = adopted === settings.adopted_status_options[0].value;
        adopted_out = adopted === settings.adopted_status_options[1].value;
      }

      let payload = {
        first_name: this.state.profile.first_name,
        age: this.state.profile.age,
        age_string: this.state.profile.age_string,
        age_estimated: this.state.profile.age_estimated,
        is_dead: this.state.profile.is_dead,
        cause_of_death: this.state.profile.cause_of_death,
        note: this.state.profile.note,
        adopted_in: adopted_in,
        adopted_out: adopted_out,
        gender: gender,
        gender_identity: gender_identity,
        carrier: this.state.profile.carrier,
        pregnancy: this.state.profile.pregnancy
      };

      if(this.props.node.data.profile.id === parseInt(this.props.probandId) ) {
        payload['last_name'] = this.state.profile.last_name;
        payload['dob'] = this.state.profile.dob;
      }
      payload['yob'] = this.state.profile.yob;

      let fields = ['yob', 'dob', 'age'];
      for(let field of fields) {
        if(payload[field] === '' || payload[field] === undefined) {
          payload[field] = null;
        }
      }

      let profile = this.props.getPedigreeData().getProfile(this.state.profile.rkey)
      let stateProfile = cloneDeep(this.state.profile)
      stateProfile.diseases = profile.diseases
      stateProfile.genetic_testing = profile.genetic_testing
      this.props.getPedigreeData().setProfile(this.state.profile.rkey, stateProfile);
      if (this.props.node.data.profile.is_proband) {
        this.props.getPedigreeData().setProband(stateProfile);
      }

      await family_api.patch_member_memberid(this.state.profile.id, payload)

      this.setPendingChanges(false);
      this.saveParentAdopted(this.state.profile);

      let data = Object.assign({}, this.state)
      //use callback
      await this.props.onOk(data, this.props.updateSubtextMargin)
      await this.props.reRenderTopBarFunction();


    } catch (error) {
      helpers.logger(error)
      this.setState({ errorMessages: [error.message] })
    }
  }

  async validate() {
    let profile = this.state.profile;
    if (profile) {

      let age = this.state.profile.age;
      // let diseases = await disease_api.get_member_id_diseases(profile.id)
      let diseases = this.props.getPedigreeData().getDiseases(this.state.profile.rkey)

      for(let disease of diseases) {
        if(age !== null && age !== '' && age !== undefined && parseInt(age, radix_bases.base10) < parseInt(disease.age_diagnosed, radix_bases.base10)) throw new Error('The current age/age at death cannot be less than the age of diagnosis entered for this person’s disease.')
      }

      if(parseInt(age, radix_bases.base10) > 130) throw new Error('Age must be less than 130.')

      if(profile.relationship_data){
        // let children = await family_api.get_members_memberid_children(profile.relationship_data.mother_id, profile.relationship_data.father_id)
        let people = Object.values(this.props.getPedigreeData().getAllProfiles())
        let children = people.filter(person => (person.mother_id == profile.relationship_data.mother_id && person.father_id == profile.relationship_data.father_id) ||
                        (person.father_id == profile.relationship_data.mother_id && person.mother_id == profile.relationship_data.father_id))

        let childrenWithYob = children.filter(child => (child.yob !== null && child.yob !== undefined && !isNaN(child.yob)))
        if(childrenWithYob.length !== 0){
          if(profile.is_dead && profile.yob && profile.age){
            let highestYobAmongChildren = childrenWithYob.sort((a, b) => Number(b.yob) - Number(a.yob));
            highestYobAmongChildren = highestYobAmongChildren[0]
            if(Number(profile.age) + Number(profile.yob) < Number(highestYobAmongChildren.yob)){
              throw new Error("Deceased date is before child/children's date of birth.")
            }
          }
        }
      }

      if(profile.mother_id !== null && profile.mother_id !== undefined && profile.mother_id !== ""){
        // let parents = await family_api.get_member_memberid_parents(profile.id)
        let people = Object.values(this.props.getPedigreeData().getAllProfiles())
        let mother = people.find(person => person.id == profile.mother_id)
        if(mother.is_dead && mother.yob && mother.age && profile.yob){
          if(Number(profile.yob) > Number(mother.yob) + Number(mother.age)){
            throw new Error("Birth date is after mother's deceased date.")
          }
        }
      }

      //needed: is_dead, age, yob of current node
      //                 age and yob of children
      //profile.mother_id is undefined if current node has no mother

      // Validate YOB
      if(this.props.node.data.profile.id !== parseInt(this.props.probandId) ) {
        let yob = profile.yob
        if(yob !== null && yob !== undefined && yob !== '' && !isNaN(parseInt(yob, radix_bases.base10))) {
          yob = yob.toString().trim();
          if(yob && yob.length !== 4) {
            throw new Error('Invalid year of birth (year must be 4 characters).');
          }

          if(parseInt(yob, radix_bases.base10) > moment().year()) {
            throw new Error('Invalid year of birth (future year is not allowed).');
          }
        }
      }

      if(this.state.profile.note && this.state.profile.note.length > 1000){
        throw new Error('Notes cannot contain more than 1000 characters')
      }
    }
  }

  async saveParentAdopted(profile) {
    try {
      let patient = this.props.getPedigreeData().getProband();
      let { father, mother} = patient;
      let payload = {
        rkey: patient.rkey
      }

      if(profile.id == father.id) {
        patient.father_adopted = profile.adopted_out;
        this.props.getPedigreeData().setProband(patient)
        this.props.getPedigreeData().setProfile(patient.rkey, patient);

        payload = {...payload, father_adopted: profile.adopted_out};
        family_api.patch_member_memberid(patient.id, payload);
      }

      if(profile.id == mother.id) {
        patient.mother_adopted = profile.adopted_out;
        this.props.getPedigreeData().setProband(patient)
        this.props.getPedigreeData().setProfile(patient.rkey, patient);

        payload = {...payload, mother_adopted: profile.adopted_out};
        family_api.patch_member_memberid(patient.id, payload);
      }

      if(profile.id == patient.id) {
        patient.adopted_out = profile.adopted_out;
        this.props.getPedigreeData().setProband(patient)
        this.props.getPedigreeData().setProfile(patient.rkey, patient);

        payload = {...payload, adopted_out: profile.adopted_out};
        family_api.patch_member_memberid(patient.id, payload);
      }

    } catch (err) {
      console.log(err)
    }
  }

  onChange(key, value) {
    let profile = cloneDeep(this.state.profile);
    if (profile) {
      if (key === 'adopted') {
        const adopted_in = value === settings.adopted_status_options[0].value;
        const adopted_out = value === settings.adopted_status_options[1].value;
        profile['adopted_in'] = adopted_in;
        profile['adopted_out'] = adopted_out;
        this.setState({ profile: profile, [key]: value });
      } else {
        profile[key] = value;
        this.setState({ profile: profile });
      }
      this.setPendingChanges(true);
    }
  }

  enablePregnancy() {
    const profile = this.props.node.data.profile
    const partners = profile.partners;
    return partners.length === 0;
  }

  handleGenderChange(field, item) {
    let profile = cloneDeep(this.state.profile);
    if (profile) {
      // let node_types = ['mother', 'father', 'paternal_grandmother', 'paternal_grandfather', 'maternal_grandmother', 'maternal_grandfather', 'partner'];
      //
      // let node_type = this.props.node.node_type;
      // let bad_node = node_types.includes(node_type);handleGenderChange
      // let partners = (node_type === 'proband') ? this.props.patient.partners['proband'] : this.props.patient.partners[this.state.profile.rkey];

      // let relationships = profile.relationship_ids

      // if ((field == 'gender' && relationships && relationships.length > 0)) {
      //   this.setState({ genderError: true })
      // } else {
      let proband = this.props.getPedigreeData().getProband();
      let proband_paternal_grandfather_id = proband.paternal_grandfather.id;
      let proband_paternal_grandmother_id = proband.paternal_grandmother.id;
      let proband_maternal_grandfather_id = proband.maternal_grandfather.id;
      let proband_maternal_grandmother_id = proband.maternal_grandmother.id;
      let restrictions = [proband.father_id, proband.mother_id, proband_paternal_grandfather_id, proband_paternal_grandmother_id, proband_maternal_grandfather_id, proband_maternal_grandmother_id];

      if(restrictions.includes(profile.id) && field === 'gender'){
        this.setState({ genderError: true })
      }
      else{
        let value = item ? item.value : null;
        if(field == 'gender') {
          profile.gender = value;
        }
        else{
          profile.gender_identity = value;
        }
        this.setState({ profile: profile, genderError: false })
        this.setPendingChanges(true);
      }
    }
  }

  toggleShowMore() {
    this.setState({ showMore: !this.state.showMore });
    let show_more = Cookie.get(CookieKeys.SIDEBAR_SHOW_MORE)
    if (show_more === 'false') {
      show_more = false
    } else if (show_more === 'true') {
      show_more = true
    }
    set_cookie(CookieKeys.SIDEBAR_SHOW_MORE, !show_more)
  }

  getFormatForDatePicker(){
    var formats = { "ar-SA": "dd/MM/y", "bg-BG": "dd.MM.y", "ca-ES": "dd/MM/y", "zh-TW": "y/MM/dd", "cs-CZ": "dd.MM.y", "da-DK": "dd-MM-y", "de-DE": "dd.MM.y", "el-GR": "dd/MM/y", "en-US": "MM/dd/y", "fi-FI": "dd.MM.y", "fr-FR": "dd/MM/y", "he-IL": "dd/MM/y", "hu-HU": "y. MM. dd.", "is-IS": "dd.MM.y", "it-IT": "dd/MM/y", "ja-JP": "y/MM/dd", "ko-KR": "y-MM-dd", "nl-NL": "dd-MM-y", "nb-NO": "dd.MM.y", "pl-PL": "y-MM-dd", "pt-BR": "dd/MM/y", "ro-RO": "dd.MM.y", "ru-RU": "dd.MM.y", "hr-HR": "dd.MM.y", "sk-SK": "dd. MM. y", "sq-AL": "y-MM-dd", "sv-SE": "y-MM-dd", "th-TH": "dd/MM/y", "tr-TR": "dd.MM.y", "ur-PK": "dd/MM/y", "id-ID": "dd/MM/y", "uk-UA": "dd.MM.y", "be-BY": "dd.MM.y", "sl-SI": "dd.MM.y", "et-EE": "dd.MM.y", "lv-LV": "y.MM.dd.", "lt-LT": "y.MM.dd", "fa-IR": "MM/dd/y", "vi-VN": "dd/MM/y", "hy-AM": "dd.MM.y", "az-Latn-AZ": "dd.MM.y", "eu-ES": "y/MM/dd", "mk-MK": "dd.MM.y", "af-ZA": "y/MM/dd", "ka-GE": "dd.MM.y", "fo-FO": "dd-MM-y", "hi-IN": "dd-MM-y", "ms-MY": "dd/MM/y", "kk-KZ": "dd.MM.y", "ky-KG": "dd.MM.YY", "sw-KE": "MM/dd/y", "uz-Latn-UZ": "dd/MM y", "tt-RU": "dd.MM.y", "pa-IN": "dd-MM-YY", "gu-IN": "dd-MM-YY", "ta-IN": "dd-MM-y", "te-IN": "dd-MM-YY", "kn-IN": "dd-MM-YY", "mr-IN": "dd-MM-y", "sa-IN": "dd-MM-y", "mn-MN": "YY.MM.dd", "gl-ES": "dd/MM/YY", "kok-IN": "dd-MM-y", "syr-SY": "dd/MM/y", "dv-MV": "dd/MM/YY", "ar-IQ": "dd/MM/y", "zh-CN": "y/MM/dd", "de-CH": "dd.MM.y", "en-GB": "dd/MM/y", "es-MX": "dd/MM/y", "fr-BE": "dd/MM/y", "it-CH": "dd.MM.y", "nl-BE": "dd/MM/y", "nn-NO": "dd.MM.y", "pt-PT": "dd-MM-y", "sr-Latn-CS": "dd.MM.y", "sv-FI": "dd.MM.y", "az-Cyrl-AZ": "dd.MM.y", "ms-BN": "dd/MM/y", "uz-Cyrl-UZ": "dd.MM.y", "ar-EG": "dd/MM/y", "zh-HK": "dd/MM/y", "de-AT": "dd.MM.y", "en-AU": "dd/MM/y", "es-ES": "dd/MM/y", "fr-CA": "y-MM-dd", "sr-Cyrl-CS": "dd.MM.y", "ar-LY": "dd/MM/y", "zh-SG": "dd/MM/y", "de-LU": "dd.MM.y", "en-CA": "dd/MM/y", "es-GT": "dd/MM/y", "fr-CH": "dd.MM.y", "ar-DZ": "dd-MM-y", "zh-MO": "dd/MM/y", "de-LI": "dd.MM.y", "en-NZ": "dd/MM/y", "es-CR": "dd/MM/y", "fr-LU": "dd/MM/y", "ar-MA": "dd-MM-y", "en-IE": "dd/MM/y", "es-PA": "MM/dd/y", "fr-MC": "dd/MM/y", "ar-TN": "dd-MM-y", "en-ZA": "y/MM/dd", "es-DO": "dd/MM/y", "ar-OM": "dd/MM/y", "en-JM": "dd/MM/y", "es-VE": "dd/MM/y", "ar-YE": "dd/MM/y", "en-029": "MM/dd/y", "es-CO": "dd/MM/y", "ar-SY": "dd/MM/y", "en-BZ": "dd/MM/y", "es-PE": "dd/MM/y", "ar-JO": "dd/MM/y", "en-TT": "dd/MM/y", "es-AR": "dd/MM/y", "ar-LB": "dd/MM/y", "en-ZW": "MM/dd/y", "es-EC": "dd/MM/y", "ar-KW": "dd/MM/y", "en-PH": "MM/dd/y", "es-CL": "dd-MM-y", "ar-AE": "dd/MM/y", "es-UY": "dd/MM/y", "ar-BH": "dd/MM/y", "es-PY": "dd/MM/y", "ar-QA": "dd/MM/y", "es-BO": "dd/MM/y", "es-SV": "dd/MM/y", "es-HN": "dd/MM/y", "es-NI": "dd/MM/y", "es-PR": "dd/MM/y", "am-ET": "dd/MM/y", "tzm-Latn-DZ": "dd-MM-y", "iu-Latn-CA": "dd/MM/y", "sma-NO": "dd.MM.y", "mn-Mong-CN": "y/MM/dd", "gd-GB": "dd/MM/y", "en-MY": "dd/MM/y", "prs-AF": "dd/MM/YY", "bn-BD": "dd-MM-YY", "wo-SN": "dd/MM/y", "rw-RW": "MM/dd/y", "qut-GT": "dd/MM/y", "sah-RU": "MM.dd.y", "gsw-FR": "dd/MM/y", "co-FR": "dd/MM/y", "oc-FR": "dd/MM/y", "mi-NZ": "dd/MM/y", "ga-IE": "dd/MM/y", "se-SE": "y-MM-dd", "br-FR": "dd/MM/y", "smn-FI": "dd.MM.y", "moh-CA": "MM/dd/y", "arn-CL": "dd-MM-y", "ii-CN": "y/mM/dd", "dsb-DE": "dd. MM. y", "ig-NG": "dd/MM/y", "kl-GL": "dd-MM-y", "lb-LU": "dd/MM/y", "ba-RU": "dd.MM.YY", "nso-ZA": "y/MM/dd", "quz-BO": "dd/MM/y", "yo-NG": "dd/MM/y", "ha-Latn-NG": "dd/MM/y", "fil-PH": "MM/dd/y", "ps-AF": "dd/MM/YY", "fy-NL": "dd-MM-y", "ne-NP": "MM/dd/y", "se-NO": "dd.MM.y", "iu-Cans-CA": "dd/MM/y", "sr-Latn-RS": "dd.MM.y", "si-LK": "y-MM-dd", "sr-Cyrl-RS": "dd.MM.y", "lo-LA": "dd/MM/y", "km-KH": "y-MM-dd", "cy-GB": "dd/MM/y", "bo-CN": "y/MM/dd", "sms-FI": "dd.MM.y", "as-IN": "dd-MM-y", "ml-IN": "dd-MM-YY", "en-IN": "dd-MM-y", "or-IN": "dd-MM-YY", "bn-IN": "dd-MM-YY", "tk-TM": "dd.MM.YY", "bs-Latn-BA": "dd.MM.y", "mt-MT": "dd/MM/y", "sr-Cyrl-ME": "dd.MM.y", "se-FI": "dd.MM.y", "zu-ZA": "y/MM/dd", "xh-ZA": "y/MM/dd", "tn-ZA": "y/MM/dd", "hsb-DE": "dd. MM. y", "bs-Cyrl-BA": "dd.MM.y", "tg-Cyrl-TJ": "dd.MM.YY", "sr-Latn-BA": "dd.MM.y", "smj-NO": "dd.MM.y", "rm-CH": "dd/MM/y", "smj-SE": "y-MM-dd", "quz-EC": "dd/MM/y", "quz-PE": "dd/MM/y", "hr-BA": "dd.MM.y.", "sr-Latn-ME": "dd.MM.y", "sma-SE": "y-MM-dd", "en-SG": "dd/MM/y", "ug-CN": "y-MM-dd", "sr-Cyrl-BA": "dd.MM.y", "es-US": "MM/dd/y" }
    return formats[navigator.language] || 'dd/MM/y';
  }

  async handleClickUnlink(event){
    try{
      this.setState({ errorMessages: [], loading: true });
      event.preventDefault();

      let member_links = cloneDeep(this.props.getPedigreeData().getMemberLinks());
      let existing_member_link = member_links.find(link => link.member_one_uuid == this.props.node.data.profile.uuid_code || link.member_two_uuid == this.props.node.data.profile.uuid_code)

      let payload = {
        member_one_uuid: existing_member_link.member_one_uuid,
        member_two_uuid: existing_member_link.member_two_uuid,
      }

      await family_api.unlink_pedigrees(payload)

      // push to member links on pedigree data store
      let new_member_links = member_links.filter((link) => link.member_one_uuid != payload.member_one_uuid && link.member_two_uuid != payload.member_two_uuid)
      this.props.getPedigreeData().setMemberLinks(new_member_links)

      // push to member links on pedigree data store
      let linked_members = cloneDeep(this.props.getPedigreeData().getLinkedMembers());
      linked_members = linked_members.filter(member => member.uuid_code != payload.member_two_uuid && member.uuid_code != payload.member_one_uuid)
      this.props.getPedigreeData().setLinkedMembers(linked_members)

      await this.props.reRenderPedigree();
      this.props.updateSubtextMargin();

      this.setState({ errorMessages: [] });
    }
    catch (error){
      console.log(error)
      this.setState({ errorMessages: [error.message] })
    }
  }

  async handleDonorFieldChange(donors, action){

    if(this.state.donorAssignReady){
      return;
    }

    // if(this.state.donor_types_selected.find(type => type.value == 'sperm_donor')){
    //   if(action.action == "select-option"){
    //     if(action.option.value == "surrogate_egg_donor"){
    //       return;
    //     }
    //   }
    // }

    // if(this.state.donor_types_selected.find(type => type.value == 'surrogate_egg_donor')){
    //   if(action.action == "select-option"){
    //     if(action.option.value == "sperm_donor"){
    //       return;
    //     }
    //   }
    // }
    let sperm_donor_selected = donors.find(type => type.value == "sperm_donor");
    let egg_donor_selected = donors.find(type => type.value == "egg_donor");
    let surrogate_selected = donors.find(type => type.value == "surrogate");
    let surrogate_egg_donor_selected = donors.find(type => type.value == "surrogate_egg_donor");

    if(action.action == "select-option"){
      switch(action.option.value){
        case "sperm_donor":
          sperm_donor_selected = true;
          break;
        case "egg_donor":
          egg_donor_selected = true;
          break;
        case "surrogate":
          surrogate_selected = true;
          break;
        case "surrogate_egg_donor":
          surrogate_egg_donor_selected = true;
          break;
        default:
          break;
      }
    }

    let people = Object.values(this.props.getPedigreeData().getAllProfiles())
    let donee = people.find(person => person.id == this.props.node.data.profile.id);
    let parent1 = people.find(person => person.id == donee.mother_id);
    let parent2 = people.find(person => person.id == donee.father_id);
    let donee_parents_are_same_sex_partners = parent1.gender == parent2.gender;

    if(donee_parents_are_same_sex_partners){
      if(surrogate_egg_donor_selected && surrogate_selected){
        return;
      }

      if(surrogate_egg_donor_selected && egg_donor_selected){
        return;
      }
    }
    else{
      if(surrogate_egg_donor_selected && surrogate_selected){
        return;
      }

      if(surrogate_egg_donor_selected && egg_donor_selected){
        return;
      }

      if(sperm_donor_selected && surrogate_egg_donor_selected){
        return;
      }

      if(sperm_donor_selected && egg_donor_selected && (surrogate_selected || surrogate_egg_donor_selected)){
        return;
      }
    }

    try{
      if(action.action == "select-option"){
        let payload = {
          child_id: this.props.node.data.profile.id,
          donor_type: action.option.value
        };
        let response = await family_api.post_donor(payload);
        let donor = response.donor;
        let profile = response.member;
        let all_donors = cloneDeep(this.props.getPedigreeData().getDonors());
        all_donors.push(donor);

        profile.rkey = `apimem-${profile.id}`;
        profile.diseases = [];
        profile.genetic_testing = [];
        profile.gene_panels = [];
        profile.family_id_id = profile.family_id;
        profile.partners = [];
        profile.relationship_ids = [];
        profile.twin_id_id = null;

        let child_profile = this.props.getPedigreeData().getProfile(this.props.node.data.profile.rkey);
        child_profile.adopted_in = false;
        this.props.getPedigreeData().setProfile(child_profile.rkey, child_profile);

        this.props.getPedigreeData().setProfile(profile.rkey, profile);
        this.props.getPedigreeData().setDonors(all_donors);
      }
      else if(action.action == "remove-value"){
        let all_donors = cloneDeep(this.props.getPedigreeData().getDonors());
        let removed_donor = all_donors.find(d => d.child_id == this.props.node.data.profile.id && d.donor_type == action.removedValue.value);
        await family_api.delete_donor(removed_donor.id);
        let all_donors_without_removed_donor = all_donors.filter(d => d.id != removed_donor.id);

        if(removed_donor.is_random_donor){
          let donor_records_with_same_donor_member_id = all_donors.filter(d => d.donor_id == removed_donor.donor_id);
          if(donor_records_with_same_donor_member_id.length == 0){
            let profile = this.props.getPedigreeData().getProfile(`apimem-${removed_donor.donor_id}`);
            this.props.deleteFromPedigreeData(profile, []);
          }
        }

        this.props.getPedigreeData().setDonors(all_donors_without_removed_donor);
      }
      else if(action.action == "clear"){
        let all_donors = cloneDeep(this.props.getPedigreeData().getDonors());
        for(let removedValue of action.removedValues){
          let removed_donor = all_donors.find(d => d.child_id == this.props.node.data.profile.id && d.donor_type == removedValue.value);
          await family_api.delete_donor(removed_donor.id);

          if(removed_donor.is_random_donor){
            let profile = this.props.getPedigreeData().getProfile(`apimem-${removed_donor.donor_id}`);
            this.props.deleteFromPedigreeData(profile, []);
          }

          let all_donors_without_removed_donor = all_donors.filter(d => d.id != removed_donor.id);
          this.props.getPedigreeData().setDonors(all_donors_without_removed_donor);
        }
      }
    }
    catch(e){
      console.log(e.stack)
    }

    this.setState({ donor_types_selected: donors }, async() => {
      await this.props.reRenderPedigree();
    });

  }

  toolTipHide = (tooltip) => {
    for (var i = tooltip.length; i--;) {
      tooltip[i].style.visibility = 'hidden';
    }
  }

  async handleAssignDonorClick(donor_record, clearValue) {
    // do the necessary checks here to see if we can assign the donor
    let sperm_donor_selected = this.state.donor_types_selected.find(type => type.value == "sperm_donor");
    let egg_donor_selected = this.state.donor_types_selected.find(type => type.value == "egg_donor");
    let surrogate_selected = this.state.donor_types_selected.find(type => type.value == "surrogate");
    let surrogate_egg_donor_selected = this.state.donor_types_selected.find(type => type.value == "surrogate_egg_donor");

    switch(donor_record.value){
      case "sperm_donor":
        sperm_donor_selected = true;
        break;
      case "egg_donor":
        egg_donor_selected = true;
        break;
      case "surrogate":
        surrogate_selected = true;
        break;
      case "surrogate_egg_donor":
        surrogate_egg_donor_selected = true;
        break;
      default:
        break;
    }

    let people = Object.values(this.props.getPedigreeData().getAllProfiles())
    let donee = people.find(person => person.id == this.props.node.data.profile.id);
    let parent1 = people.find(person => person.id == donee.mother_id);
    let parent2 = people.find(person => person.id == donee.father_id);
    let donee_parents_are_same_sex_partners = parent1.gender == parent2.gender;

    if(donee_parents_are_same_sex_partners){
      if(surrogate_egg_donor_selected && surrogate_selected){
        return;
      }

      if(surrogate_egg_donor_selected && egg_donor_selected){
        return;
      }
    }
    else{
      if(surrogate_egg_donor_selected && surrogate_selected){
        return;
      }

      if(surrogate_egg_donor_selected && egg_donor_selected){
        return;
      }

      if(sperm_donor_selected && surrogate_egg_donor_selected){
        return;
      }

      if(sperm_donor_selected && egg_donor_selected && (surrogate_selected || surrogate_egg_donor_selected)){
        return;
      }
    }

    this.props.getPedigreeData().setDonorAssign(true, donor_record, this.props.node.data.profile.id);
    window.addEventListener('mousemove', this.props.donorAssignToolTipTrack, false);
    await this.props.reRenderPedigree();

    // await this.props.openDeleteReportModal(donor_record);
    // if (
    //   this.state.readyToDelete &&
    //   this.state.currentActiveReport.value !== report.value
    // ) {
    //   await this.donorSelectRef.select.setValue(this.state.currentActiveReport);
    // }
    // if (this.state.currentActiveReport.value === null) {
    //   await this.donorSelectRef.select.clearValue();
    // }
    // await this.readyToDeleteOff();
  }

  donorAssignReadyOn() {
    this.setState({ donorAssignReady: true });
  }

  donorAssignReadyOff() {
    this.setState({ donorAssignReady: false });
  }

  isOptionDisabled(option){
    let sperm_donor_selected = this.state.donor_types_selected.find(type => type.value == "sperm_donor");
    let egg_donor_selected = this.state.donor_types_selected.find(type => type.value == "egg_donor");
    let surrogate_selected = this.state.donor_types_selected.find(type => type.value == "surrogate");
    let surrogate_egg_donor_selected = this.state.donor_types_selected.find(type => type.value == "surrogate_egg_donor");

    // assume that the user will try to select these values
    if(!sperm_donor_selected){
      sperm_donor_selected = option.value == "sperm_donor"
    }
    if(!egg_donor_selected){
      egg_donor_selected = option.value == "egg_donor"
    }
    if(!surrogate_selected){
      surrogate_selected = option.value == "surrogate"
    }
    if(!surrogate_egg_donor_selected){
      surrogate_egg_donor_selected = option.value == "surrogate_egg_donor"
    }

    let isDisabled = false;

    let people = Object.values(this.props.getPedigreeData().getAllProfiles())
    let donee = people.find(person => person.id == this.props.node.data.profile.id);
    let parent1 = people.find(person => person.id == donee.mother_id);
    let parent2 = people.find(person => person.id == donee.father_id);
    let donee_parents_are_same_sex_partners = parent1.gender == parent2.gender;

    if(donee_parents_are_same_sex_partners){
      if((surrogate_egg_donor_selected && surrogate_selected) || (surrogate_egg_donor_selected && egg_donor_selected)){
        isDisabled = true;
      }
    }
    else{
      if((surrogate_egg_donor_selected && surrogate_selected) || (surrogate_egg_donor_selected && egg_donor_selected) || (sperm_donor_selected && surrogate_egg_donor_selected) || (sperm_donor_selected && egg_donor_selected && (surrogate_selected || surrogate_egg_donor_selected))){
        isDisabled = true;
      }
    }

    return isDisabled;
  }

  render() {
    let gender_options = [
      settings.app_constants.patientData.genders.male,
      settings.app_constants.patientData.genders.female,
      settings.app_constants.patientData.genders.unknown
    ];

    let gender_identity_options = [
      settings.app_constants.patientData.genderIdentity.male,
      settings.app_constants.patientData.genderIdentity.female,
      settings.app_constants.patientData.genderIdentity.nonBinary
    ];

    let adopted = helpers.getSelectedOption(
      settings.adopted_status_options,
      this.state.adopted
    );

    let gender = helpers.getSelectedOption(gender_options, 'U');
    let gender_identity = helpers.getSelectedOption(gender_identity_options, '');
    let pregnancy = false;
    let carrier = false;
    if (this.state.profile) {
      const g = (this.state.profile.gender) ? this.state.profile.gender.toUpperCase() : 'U';
      const g_i = (this.state.profile.gender_identity) ? this.state.profile.gender_identity : '';
      gender = helpers.getSelectedOption(gender_options, g);
      gender_identity = helpers.getSelectedOption(gender_identity_options, g_i);
      pregnancy = this.state.profile.pregnancy;
      carrier = this.state.profile.carrier;
    }

    let show_more = Cookie.get(CookieKeys.SIDEBAR_SHOW_MORE)
    if (show_more === 'false') {
      show_more = false
    } else if (show_more === 'true') {
      show_more = true
    }

    let show_more_label = (<React.Fragment>Show More <i className="fa fa-chevron-down"></i></React.Fragment>);
    if (show_more) {
      show_more_label = (<React.Fragment>Show Less <i className="fa fa-chevron-up"></i></React.Fragment>)
    }

    let custom_data_label = (<React.Fragment>Custom Data <i className="fa fa-chevron-right"></i></React.Fragment>);

    // CHECK IF HAS PROBAND RECORD WITH THE SAME UUID
    let cloned_members = this.props.getPedigreeData().getClonedMembers()
    let has_existing_proband_record = cloned_members.find(patient => patient.uuid_code == this.props.node.data.profile.uuid_code)

    let linked_members = this.props.getPedigreeData().getLinkedMembers()

    // CHECK IF MANUALLY LINKED
    let manually_linked_proband = null;
    let check_if_manually_linked = this.props.getPedigreeData().getMemberLinks().find(link => link.member_one_uuid == this.props.node.data.profile.uuid_code || link.member_two_uuid == this.props.node.data.profile.uuid_code)
    if(check_if_manually_linked){
      manually_linked_proband = linked_members.find(proband => proband.uuid_code == check_if_manually_linked.member_two_uuid || proband.uuid_code == check_if_manually_linked.member_one_uuid)
    }

    let dob = '';
    if (this.getProfileValue('dob')) {
      try {
        dob = new Date(this.getProfileValue('dob') + "T12:00:00");
      } catch (error) {
        dob = '';
      }
    }
    let minDate = new Date('1800-01-01' + "T12:00:00")
    let age_disabled = this.state.profile ? (!this.state.profile.is_dead && this.state.profile.is_proband && this.state.profile.dob) : false
    return (
      <div className="form-horizontal">

        <ErrorSummary errorMessages={this.state.errorMessages} />

        <div className="form-group">
          <label htmlFor="first_name" className="col-sm-4 control-label">First Name</label>
          <div className="col-sm-8">
            <input
              id='member_info_first_name'
              name='first_name'
              onChange={this.handleProfileChange}
              type="text" className="form-control normal-input-text" value={this.getProfileValue('first_name')} />
          </div>
        </div>

        <div className="form-group" style={{display: 'flex'}}>
          {this.getProfileValue('is_dead') ? (<label htmlFor="age" className="col-sm-4 control-label">Age at Death</label>) : (<label htmlFor="age" className="col-sm-4 control-label">Age</label>)}
          <div className="col-sm-8" style={{width: "25%", marginLeft: 20}}>
            <input
              id='member_info_age'
              name="age_string"
              disabled={age_disabled}
              onChange={this.handleAgeChange}
              value={this.getAgeValue()}
              type="text" className="form-control normal-input-text" />
          </div>
            <label htmlFor="age_estimated" className="col-sm-4 control-label">Estimated</label>
            <div className="checkbox" style={{marginRight: 20}}>
              <label className="switch">
                <input
                  id='member_info_age_estimated'
                  name="age_estimated"
                  onChange={this.handleProfileChange}
                  checked={this.getProfileValue('age_estimated')}
                  type="checkbox"/>
                <span className="slider round"></span>
              </label>
            </div>
        </div>
        {this.state.ageError && (
          <div className="validation-inline__error-text validation-warning-age-member-info">
            Age/Age at death cannot be less than age at diagnosis.
          </div>
        )}

        {this.props.node.data.profile.id === parseInt(this.props.probandId) && (
          <div className="form-group">
            <label htmlFor="dob" className="col-sm-4 control-label">Date of Birth</label>
            <div className="col-sm-8">
              {/* <input
                id="member_info_dob"
                name="dob"
                onChange={this.handleProfileChange}
                value={this.getProfileValue("dob")}
                style={{ lineHeight: 1.42857143 }}
                type="date"
                className="form-control"
                placeholder="mm-dd-yyyy"
              /> */}
              <DatePicker
                id="member_info_dob"
                name="dob"
                onChange={this.onChangeDate}
                value={dob}
                className="form-control"
                calendarIcon={null}
                clearIcon={null}
                dayPlaceholder={"dd"}
                monthPlaceholder={"mm"}
                yearPlaceholder={"yyyy"}
                disableCalendar={true}
                showLeadingZeros={true}
                minDate={minDate}
              />
            </div>
          </div>
        )}

        {this.props.node.data.profile.id !== parseInt(this.props.probandId) && (
          <div className="form-group">
            <label htmlFor="yob" className="col-sm-4 control-label">Year of Birth</label>
            <div className="col-sm-8">
              <input
                id='member_info_yob'
                name="yob" onChange={this.handleProfileChange} value={this.getProfileValue('yob')}
                type="number" className="form-control normal-input-text" />
            </div>
            {this.state.deceaseError && (
                <div className="validation-inline__error-text validation-warning">
                  {this.state.deceaseError}
                </div>
            )}
          </div>
        )}

        <div className="form-group">
          <label htmlFor="is_dead" className="col-sm-4 control-label">Deceased?</label>

          <div className="col-sm-8">
            <div className="checkbox">
              <label className="switch">
                <input
                  id='member_info_is_dead'
                  name="is_dead"
                  onChange={this.handleProfileChange}
                  checked={this.getProfileValue('is_dead')}
                  type="checkbox"/>
                <span className="slider round"></span>
              </label>
            </div>
          </div>

        </div>

        {this.getProfileValue('is_dead') && (
          <div className="form-group">
            <label htmlFor="cause_of_death" className="col-sm-4 control-label">Cause of Death</label>
            <div className="col-sm-8">
              <input
                id='member_info_cause_of_death'
                name="cause_of_death"
                onChange={this.handleProfileChange}
                value={this.getProfileValue('cause_of_death')}
                type="text" className="form-control normal-input-text" />
            </div>
          </div>
        )}

        <div className="form-group">
          <label htmlFor="note" className="col-sm-4 control-label">Notes</label>
          <div className="col-sm-8">
            <textarea
              id='member_info_note'
              name="note"
              onChange={this.handleProfileChange}
              value={this.getProfileValue('note')}
              className="form-control"  />
          </div>
        </div>

        {show_more && (
          <React.Fragment>
            <div className="form-group">
              <label htmlFor="gender" className="col-sm-4 control-label">Sex at Birth</label>

              <div className="col-sm-8">
                <Select
                  value={gender}
                  id='member_info_gender'
                  name="gender"
                  onChange={item => this.handleGenderChange('gender', item)}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  isClearable={true}
                  placeholder=""
                  options={gender_options}
                />
              </div>
              {this.state.genderError && (
                <div className="validation-inline__error-text validation-warning">
                  {/* You cannot change the sex assigned at birth of pedigree members who have partners. */}
                  You cannot change the sex assigned at birth of basic family members.
                </div>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="gender" className="col-sm-4 control-label">Gender</label>

              <div className="col-sm-8">
                <Select
                  value={gender_identity}
                  id='member_info_gender_identity'
                  name="gender_identity"
                  onChange={item => this.handleGenderChange('gender_identity', item)}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  isClearable={true}
                  placeholder=""
                  options={gender_identity_options}
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="adopted" className="col-sm-4 control-label">Adopted</label>
              <div className="col-sm-8">
                <div className="custom-select">
                  <Select
                    id='member_info_adopted'
                    value={adopted}
                    onChange={item => {
                      let value = item ? item.value : null;
                      this.onChange("adopted", value);
                    }}
                    className="react-select-container"
                    classNamePrefix="react-select"
                    isClearable={true}
                    placeholder=""
                    options={settings.adopted_status_options}
                  />
                </div>
              </div>
            </div>

            {this.props.node.data.profile.father_id && this.props.node.data.profile.mother_id && <div className="form-group">
              <label htmlFor="adopted" className="col-sm-4 control-label">Donor/Surrogate</label>
              <div className="col-sm-8">
                <div className="custom-select" id="member_info_donor_surrogate">
                  <Select
                    ref={(ref) => {
                      this.donorSelectRef = ref;
                    }}
                    value={this.state.donor_types_selected}
                    name="donor"
                    onChange={(event, action) => this.handleDonorFieldChange(event, action)}
                    handleAssignDonorClick={(donor_record, clearValue) => this.handleAssignDonorClick(donor_record, clearValue)}
                    donorAssignReadyOn={() => this.donorAssignReadyOn()}
                    donorAssignReadyOff={() => this.donorAssignReadyOff()}
                    donorAssignReady={this.state.donorAssignReady}
                    className="react-select-container"
                    classNamePrefix="react-select"
                    isClearable={true}
                    isMulti
                    placeholder=""
                    options={donor_type_options}
                    isOptionDisabled={(option) => this.isOptionDisabled(option)}
                    components={{ Option: IconOption }}
                  />
                </div>
              </div>
            </div>}

            {this.state.enablePregnancy && (
              <div className="form-group no-margin-bottom">
                <label htmlFor="pregnancy" className="col-sm-4 control-label">
                  Pregnancy?
                </label>
                <div className="col-sm-8">
                  <div className="checkbox no-margin-top">
                    <label className="switch">
                      <input
                        id='member_info_pregnancy'
                        onChange={e => {
                          this.onChange("pregnancy", e.target.checked);
                        }}
                        checked={pregnancy}
                        type="checkbox"
                        data-toggle="modal"
                      />
                      <span className="slider round" />
                    </label>
                  </div>
                </div>
              </div>
            )}

            <div className="form-group no-margin-bottom">
              <label  htmlFor="carrier" className="col-sm-4 control-label">
                Carrier?
              </label>
              <div className="col-sm-8">
                <div className="checkbox no-margin-top">
                  <label className="switch">
                    <input
                      id='member_info_carrier'
                      onChange={e => {
                        this.onChange("carrier", e.target.checked);
                      }}
                      checked={carrier}
                      type="checkbox"
                      data-toggle="modal"
                    />
                    <span className="slider round" />
                  </label>
                </div>
              </div>
            </div>

            {!this.props.node.data.profile.is_proband &&
              <div className="form-group no-margin-bottom">
                <div style={{display: 'flex', alignItems: 'center'}}>
                  <label  htmlFor="carrier" className="col-sm-4 control-label">
                    Patient Record
                  </label>
                  <div className="col-sm-8">
                    <div className="checkbox no-margin-top">
                      <div>
                        {
                          has_existing_proband_record || manually_linked_proband ? <span><a id='view-record-member-info' onClick={(event) => this.navigateToRecord(event, has_existing_proband_record ? has_existing_proband_record.id : manually_linked_proband.id)} className="link">View Record</a>{manually_linked_proband && <a onClick={(event) => this.handleClickUnlink(event)}><i className="fa fa-unlink"></i></a>}</span>
                          :
                          <a onClick={() => this.props.openShowCreateOrLinkPedigreeModal()} className="link">Create or Link</a>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }

          </React.Fragment>
        )}

        <div className="margin-three-top">
          <a onClick={this.toggleShowMore} className="link">{show_more_label}</a>
          {this.state && this.state.profile && !this.state.profile.is_proband &&
            <a onClick={this.props.showCustomDataSurvey} className="link" style={{marginLeft: '42%'}}>{custom_data_label}</a>
          }
        </div>
      </div>
    );
  }

}

export default MemberInfo


const IconOption = (props) => {
  return (
    <components.Option {...props}>
      {props.isDisabled ? <span style={{color: "#999"}}>{props.data.label}</span> : props.data.label}
      <a
        className='i-tooltip-assign-donor'
        style={{ right: 10, position: 'absolute'}}
        onClick={() =>
          props.selectProps.handleAssignDonorClick(props.data, props.clearValue)
        }
      >
        {/* {!props.isDisabled &&
        <span className="assign-donor-tooltip">
          <i
            onMouseEnter={() => props.selectProps.donorAssignReadyOn()}
            onMouseLeave={() => props.selectProps.donorAssignReadyOff()}
            style={{
              display: 'block',
              cursor: "pointer",
              float: "right",
              marginTop: "4px",
            }}
            className="fa fa-external-link"
          >
            <span
              className="tooltiptext"
            >
              Assign to existing individual
            </span>
          </i>
        </span>} */}
          <i
            onMouseEnter={() => props.selectProps.donorAssignReadyOn()}
            onMouseLeave={() => props.selectProps.donorAssignReadyOff()}
            style={{
              display: 'block',
              cursor: "pointer",
              float: "right",
              marginTop: "4px",
            }}
            className="fa fa-external-link"
          >
          </i>
          <span className="i-tooltiptext-assign-donor">
            Assign to existing individual
          </span>
      </a>
    </components.Option>
  );
};
